import { gql } from 'graphql-request';

export const siteContextQuery = gql`
    query getSiteContext($siteId: String!) {
        projectDefinition: getProjectSummary(projectId: $siteId) {
            projectId
            projectName
            projectType
            status
            area
            country
            subscription {
                label
                name
            }
            targetOutcome
            speciesOfInterest
        }
    }
`;

export type SiteContextData = {
    projectId: string;
    projectName: string;
    projectType?: string;
    status?: string;
    area?: number;
    country?: string;
    subscription?: { label?: string; name?: string } | null;
    targetOutcome?: string | null;
    speciesOfInterest?: string | null;
};

export type SiteContextQueryResult = {
    projectDefinition: SiteContextData;
};
